import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';

const statements = {
  de: "WIR SIND EIN LEIDENSCHAFTLICHES UND ERFAHRENES SCHWEIZER TEAM, DAS SICH DER ERSTELLUNG PROFESSIONELLER WEBSEITEN UND DIGITALER LÖSUNGEN WIDMET.",
  it: "SIAMO UN TEAM SVIZZERO APPASSIONATO ED ESPERTO, DEDICATO ALLA CREAZIONE DI SITI WEB PROFESSIONALI E SOLUZIONI DIGITALI.",
  en: "WE ARE A PASSIONATE AND EXPERIENCED SWISS TEAM DEDICATED TO CREATING PROFESSIONAL WEBSITES AND DIGITAL SOLUTIONS.",
  es: "SOMOS UN EQUIPO SUIZO APASIONADO Y EXPERIMENTADO DEDICADO A LA CREACIÓN DE SITIOS WEB PROFESIONALES Y SOLUCIONES DIGITALES."
};

export default function AboutStatementSection() {
  const { language } = useLanguage();
  const statement = statements[language] || statements.de;

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="about-statement-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        {/* Giant Statement - Like Dyson Template */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#0a0a0a] font-['Manrope'] leading-tight tracking-tight">
            {statement}
          </h2>
        </motion.div>
      </div>
    </section>
  );
}
